import React from 'react';
import { Box } from '@mui/material';

import { Typography, CardContent, CardHeader, Card } from '@occc/ui-design-system';

type Props = {
  title: string;
};

export const UnconfiguredOfferComponentPanel: React.FC<Props> = (props) => {
  const { title } = props;
  return (
    <Box>
      <Card disabled={true}>
        <CardHeader
          title={
            <Typography component='h3' variant='h6'>
              {title}
            </Typography>
          }
        />
        <CardContent>
          <Typography>
            The {title} component was not configured at the time of Offer creation. If you want to
            configure the {title} component, you will need to create a new offer.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
